import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import saga from './saga';
import { initialState, createReducer } from './reducer';
import { Iterable } from 'immutable';

const sagaMiddleware = createSagaMiddleware();
const loggerMiddleware = createLogger({
  collapsed: true,
  stateTransformer(state) {
    let newState = {};

    for (let i of Object.keys(state)) {
      if (Iterable.isIterable(state[i])) {
        newState[i] = state[i].toJS();
      } else {
        newState[i] = state[i];
      }
    }

    return newState;
  },
});

const enhancers = [applyMiddleware(sagaMiddleware)];

if (process.env.NODE_ENV !== 'production') {
  enhancers.push(applyMiddleware(loggerMiddleware));
}

if (window.devToolsExtension) {
  enhancers.push(window.devToolsExtension());
}

const store = createStore(createReducer(), initialState, compose(...enhancers));
store.asyncReducers = {};
sagaMiddleware.run(saga);

export const injectReducer = (reducers: { [string]: Function } = {}) => {
  store.asyncReducers = {
    ...store.asyncReducers,
    ...reducers,
  };
  store.replaceReducer(createReducer(store.asyncReducers));
};

export const injectSaga = saga => {
  sagaMiddleware.run(saga);
};

export default store;



// WEBPACK FOOTER //
// ./src/store.js